export default __webpack_public_path__ + "static/headstand-shoulderstrength-2-a2bfbf2c3329a4611fce4aaf17f0a2bf.jpg";